import React, { Component } from 'react'
import PropTypes from 'prop-types'

import 'lazysizes'

import placeholder from '../assets/images/placeholder.png'

class ResponsiveImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false
    }

    this.onLoad = this.onLoad.bind(this)
  }

  onLoad() {
    this.setState({ loading: false })
  }

  componentDidMount() {
    if (this._image) {
      this._image.addEventListener('lazyloaded', this.onLoad)
    }
  }

  componentWillUnmount() {
    if (this._image) {
      this._image.removeEventListener('lazyloaded', this.onLoad)
    }
  }

  render() {
    const { image } = this.props

    if (!image) {
      return 'Placeholder TODO'
    }

    let src = image.sizes.thumb
    if (this.props.size) {
      src = image.sizes[this.props.size]
    }

    // fix for unknown api error which returns full as giant thumb
    if (src && this.props.size === 'full' && src.includes('giant_thumb')) {
      src = src.replace('giant_thumb_', '')
    }

    return (
      <div
        className={
          'image-wrapper pu-trigger ' + (this.state.loading ? 'loading' : '')
        }
      >
        <img
          ref={e => (this._image = e)}
          src={placeholder}
          data-src={src}
          className={
            'img img-fluid lazyload ' +
            (this.props.className ? this.props.className : '')
          }
          alt={image.alt || `Image ${image.id}`}
        />
      </div>
    )
  }
}

ResponsiveImage.propTypes = {
  image: PropTypes.object,
  alt: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string
}

export default ResponsiveImage
